// Small painted 2D loops for the Living Windows: each reads as its own world (pond, two birds under the moon, falling leaves).
const TAU = Math.PI * 2;

function cover(g, img, W, H, alpha, drift = 0) {
  if (!img?.complete || !img.naturalWidth) return;
  const s = Math.max(W / img.naturalWidth, H / img.naturalHeight) * 1.08;
  const w = img.naturalWidth * s;
  const h = img.naturalHeight * s;
  g.globalAlpha = alpha;
  g.drawImage(img, (W - w) / 2 + Math.sin(drift) * 6, (H - h) / 2, w, h);
  g.globalAlpha = 1;
}

function grad(g, W, H, stops) {
  const l = g.createLinearGradient(0, 0, 0, H);
  stops.forEach(([o, c]) => l.addColorStop(o, c));
  g.fillStyle = l;
  g.fillRect(0, 0, W, H);
}

function lightTop(g, W, H, col) {
  const r = g.createRadialGradient(W / 2, -H * 0.1, 10, W / 2, -H * 0.1, H * 0.9);
  r.addColorStop(0, col);
  r.addColorStop(1, "rgba(255,255,255,0)");
  g.fillStyle = r;
  g.fillRect(0, 0, W, H);
}

function pad(g, x, y, rx, ry, rot) {
  g.save();
  g.translate(x, y);
  g.rotate(rot);
  g.fillStyle = "#5E8C57";
  g.beginPath();
  g.moveTo(0, 0);
  g.ellipse(0, 0, rx, ry, 0, 0.35, TAU - 0.35);
  g.closePath();
  g.fill();
  g.strokeStyle = "rgba(205,235,190,0.55)";
  g.lineWidth = 1.5;
  g.beginPath();
  g.ellipse(0, 0, rx * 0.92, ry * 0.85, 0, 0.5, TAU - 0.6);
  g.stroke();
  g.restore();
}

function lotus(g, x, y, s, sway) {
  g.save();
  g.translate(x, y);
  g.rotate(sway);
  for (let i = 0; i < 7; i++) {
    const a = -Math.PI / 2 + (i - 3) * 0.36;
    g.save();
    g.rotate(a + Math.PI / 2);
    const pg = g.createLinearGradient(0, 0, 0, -s);
    pg.addColorStop(0, "#F6D9DF");
    pg.addColorStop(1, "#E6849F");
    g.fillStyle = pg;
    g.beginPath();
    g.moveTo(0, 0);
    g.bezierCurveTo(s * 0.32, -s * 0.35, s * 0.2, -s * 0.8, 0, -s * (i === 3 ? 1.1 : 0.95));
    g.bezierCurveTo(-s * 0.2, -s * 0.8, -s * 0.32, -s * 0.35, 0, 0);
    g.fill();
    g.restore();
  }
  g.restore();
}

function bgPond(g, W, H, img) {
  grad(g, W, H, [[0, "#DCEBE6"], [0.45, "#9CC3BE"], [1, "#4F7F7D"]]);
  cover(g, img, W, H, 0.3, 0);
}

function drawPond(g, W, H, t) {
  g.lineCap = "round";
  for (let i = 0; i < 16; i++) {
    const y = H * (0.18 + i * 0.05) + Math.sin(t * 0.6 + i) * 3;
    const x = ((i * 73 + t * (8 + (i % 3) * 4)) % (W + 80)) - 40;
    g.strokeStyle = `rgba(255,255,250,${0.18 + 0.12 * Math.sin(t + i)})`;
    g.lineWidth = 2;
    g.beginPath();
    g.moveTo(x, y);
    g.lineTo(x + 26 + (i % 4) * 8, y);
    g.stroke();
  }
  [[0.3, 0.58], [0.7, 0.42], [0.55, 0.8]].forEach(([px, py], k) => {
    const r = (t * 0.38 + k / 3) % 1;
    g.strokeStyle = `rgba(255,255,255,${(1 - r) * 0.55})`;
    g.lineWidth = 1.6;
    g.beginPath();
    g.ellipse(W * px, H * py, 8 + r * 70, (8 + r * 70) * 0.3, 0, 0, TAU);
    g.stroke();
  });
  const pads = [[0.22, 0.5, 40], [0.74, 0.62, 46], [0.4, 0.74, 52], [0.8, 0.86, 44], [0.2, 0.9, 50], [0.62, 0.34, 30]];
  pads.forEach(([px, py, r], i) => {
    const bob = Math.sin(t * 0.9 + i * 1.3) * 5;
    pad(g, W * px + Math.sin(t * 0.3 + i) * 16, H * py + bob, r, r * 0.34, i * 1.1 + Math.sin(t * 0.4 + i) * 0.25);
  });
  lotus(g, W * 0.74 + Math.sin(t * 0.3 + 1) * 16, H * 0.6 + Math.sin(t * 0.9 + 1.3) * 5, 30, Math.sin(t * 0.8) * 0.14);
  lotus(g, W * 0.22 + Math.sin(t * 0.3) * 16, H * 0.48 + Math.sin(t * 0.9) * 5, 24, Math.sin(t * 0.7 + 1) * 0.14);
  lightTop(g, W, H, "rgba(255,250,232,0.45)");
}

function bird(g, x, y, s, flip, col, head, wing) {
  g.save();
  g.translate(x, y);
  g.scale(flip, 1);
  g.fillStyle = col;
  g.beginPath();
  g.moveTo(-s * 1.1, s * 0.15);
  g.bezierCurveTo(-s * 0.6, -s * 0.6, s * 0.5, -s * 0.7, s * 0.65, -s * 0.1);
  g.bezierCurveTo(s * 0.5, s * 0.45, -s * 0.4, s * 0.55, -s * 1.1, s * 0.15);
  g.fill();
  g.beginPath();
  g.moveTo(-s * 1.0, s * 0.1);
  g.lineTo(-s * 1.6, s * 0.35);
  g.lineTo(-s * 1.0, s * 0.3);
  g.fill();
  g.save();
  g.translate(s * 0.55, -s * 0.45 + head);
  g.beginPath();
  g.ellipse(0, 0, s * 0.36, s * 0.32, 0, 0, TAU);
  g.fill();
  g.fillStyle = "#E8B04A";
  g.beginPath();
  g.moveTo(s * 0.3, -s * 0.02);
  g.lineTo(s * 0.55, s * 0.05);
  g.lineTo(s * 0.3, s * 0.1);
  g.fill();
  g.fillStyle = "#2A2440";
  g.fillRect(s * 0.1, -s * 0.1, s * 0.07, s * 0.07);
  g.restore();
  g.fillStyle = "rgba(0,0,0,0.14)";
  g.beginPath();
  g.moveTo(-s * 0.5, -s * 0.05);
  g.quadraticCurveTo(s * 0.05, -s * (0.55 + wing), s * 0.35, -s * 0.05);
  g.quadraticCurveTo(-s * 0.05, s * 0.2, -s * 0.5, -s * 0.05);
  g.fill();
  g.restore();
}

const BLOSSOMS = Array.from({ length: 10 }, (_, i) => ({ x: (i * 0.173 + 0.08) % 1, ph: (i * 0.29) % 1, sp: 0.06 + (i % 4) * 0.015, s: 7 + (i % 3) * 2 }));
function blossom(g, x, y, s, rot) {
  g.save();
  g.translate(x, y);
  g.rotate(rot);
  g.fillStyle = "rgba(248,196,214,0.95)";
  for (let i = 0; i < 5; i++) {
    g.rotate(TAU / 5);
    g.beginPath();
    g.ellipse(0, -s * 0.55, s * 0.3, s * 0.55, 0, 0, TAU);
    g.fill();
  }
  g.fillStyle = "#F6E08A";
  g.fillRect(-1.5, -1.5, 3, 3);
  g.restore();
}

function bgLove(g, W, H, img) {
  grad(g, W, H, [[0, "#1C2556"], [0.6, "#34407E"], [1, "#4B3F7A"]]);
  cover(g, img, W, H, 0.22, 0);
}

function drawLove(g, W, H, t) {
  const mx = W * 0.6;
  const my = H * 0.26;
  g.lineCap = "round";
  for (let k = 0; k < 7; k++) {
    const r = 58 + k * 17;
    const a = t * 0.24 * (k % 2 ? 1 : -1) + k;
    g.strokeStyle = k % 2 ? "rgba(250,232,160,0.5)" : "rgba(170,200,255,0.45)";
    g.lineWidth = 6 - k * 0.5;
    g.beginPath();
    g.arc(mx, my, r, a, a + 1.4 + (k % 3) * 0.4);
    g.stroke();
  }
  for (let s = 0; s < 3; s++) {
    g.strokeStyle = "rgba(190,210,255,0.35)";
    g.lineWidth = 4;
    g.beginPath();
    for (let i = 0; i <= 40; i++) {
      const th = i * 0.16 + t * 0.3 + s * 2.1;
      const rr = 6 + i * 1.3;
      const x = W * (0.15 + s * 0.3) + Math.cos(th) * rr;
      const y = H * (0.12 + s * 0.12) + Math.sin(th) * rr * 0.7;
      i ? g.lineTo(x, y) : g.moveTo(x, y);
    }
    g.stroke();
  }
  const glow = g.createRadialGradient(mx, my, 10, mx, my, 120);
  glow.addColorStop(0, "rgba(255,246,200,0.75)");
  glow.addColorStop(1, "rgba(255,246,200,0)");
  g.fillStyle = glow;
  g.fillRect(mx - 120, my - 120, 240, 240);
  g.fillStyle = "#FDF1C0";
  g.beginPath();
  g.arc(mx, my, 40, 0, TAU);
  g.fill();
  g.fillStyle = "rgba(255,255,255,0.8)";
  [[0.12, 0.42], [0.86, 0.55], [0.3, 0.2], [0.9, 0.12], [0.2, 0.62]].forEach(([sx, sy], i) => {
    const k = 3 + 2 * Math.sin(t * 1.3 + i * 2);
    g.fillRect(W * sx - k, H * sy - 0.6, k * 2, 1.2);
    g.fillRect(W * sx - 0.6, H * sy - k, 1.2, k * 2);
  });
  g.strokeStyle = "#3B2A26";
  g.lineWidth = 9;
  g.beginPath();
  g.moveTo(-10, H * 0.72);
  g.bezierCurveTo(W * 0.3, H * 0.66, W * 0.6, H * 0.7, W + 10, H * 0.63);
  g.stroke();
  g.lineWidth = 4;
  g.beginPath();
  g.moveTo(W * 0.78, H * 0.655);
  g.quadraticCurveTo(W * 0.86, H * 0.6, W * 0.92, H * 0.56);
  g.stroke();
  [[0.15, 0.7], [0.88, 0.57], [0.66, 0.68]].forEach(([lx, ly], i) => {
    g.save();
    g.translate(W * lx, H * ly);
    g.rotate(-0.6 + i * 0.5 + Math.sin(t * 0.8 + i) * 0.06);
    g.fillStyle = "#4E6B4A";
    g.beginPath();
    g.ellipse(0, -8, 5, 11, 0, 0, TAU);
    g.fill();
    g.restore();
  });
  const hop = Math.max(0, Math.sin(t * 0.7)) ** 6;
  const nestle = Math.sin(t * 0.8) * 5;
  bird(g, W * 0.4 + nestle, H * 0.655, 22, 1, "#E9D6F0", Math.sin(t * 1.4) * 4, hop * 0.6);
  bird(g, W * 0.56 - nestle, H * 0.65, 21, -1, "#F3C3B5", Math.sin(t * 1.4 + 2) * 4, Math.max(0, Math.sin(t * 0.7 + 2.5)) ** 6 * 0.5);
  BLOSSOMS.forEach((b) => {
    const y = (((t * b.sp + b.ph) % 1.1) - 0.05) * H;
    const x = b.x * W + Math.sin(t * 1.2 + b.ph * 8) * 22;
    blossom(g, x, y, b.s, t * 1.4 + b.ph * 6);
  });
  lightTop(g, W, H, "rgba(200,215,255,0.18)");
}

const LEAVES = Array.from({ length: 22 }, (_, i) => ({ x: (i * 0.137 + 0.05) % 1, ph: (i * 0.311) % 1, sp: 0.045 + (i % 5) * 0.012, s: 14 + (i % 4) * 5, c: ["#E39A4C", "#D9774A", "#E8C25A", "#9DB86A", "#D88A9A"][i % 5] }));

function leaf(g, x, y, s, rot, col) {
  g.save();
  g.translate(x, y);
  g.rotate(rot);
  g.fillStyle = col;
  g.beginPath();
  g.moveTo(0, -s);
  g.bezierCurveTo(s * 0.55, -s * 0.5, s * 0.5, s * 0.5, 0, s);
  g.bezierCurveTo(-s * 0.5, s * 0.5, -s * 0.55, -s * 0.5, 0, -s);
  g.fill();
  g.strokeStyle = "rgba(90,50,30,0.45)";
  g.lineWidth = 1.2;
  g.beginPath();
  g.moveTo(0, -s * 0.9);
  g.lineTo(0, s * 1.15);
  g.stroke();
  g.restore();
}

function bgDream(g, W, H, img) {
  grad(g, W, H, [[0, "#E9C9D6"], [0.5, "#D6B79C"], [1, "#8FA874"]]);
  cover(g, img, W, H, 0.5, 0);
  g.fillStyle = "rgba(80,56,48,0.5)";
  [[0.08, 18], [0.9, 24], [0.22, 10]].forEach(([tx, tw], i) => {
    g.beginPath();
    g.moveTo(W * tx - tw / 2, H);
    g.bezierCurveTo(W * tx - tw / 2 + 4, H * 0.6, W * tx - tw / 3, H * 0.3, W * tx + (i - 1) * 6, -10);
    g.lineTo(W * tx + tw / 2, -10);
    g.bezierCurveTo(W * tx + tw / 3, H * 0.3, W * tx + tw / 2, H * 0.6, W * tx + tw / 2, H);
    g.fill();
  });
  const mist = g.createLinearGradient(0, H * 0.55, 0, H);
  mist.addColorStop(0, "rgba(255,248,240,0)");
  mist.addColorStop(1, "rgba(255,248,240,0.3)");
  g.fillStyle = mist;
  g.fillRect(0, 0, W, H);
  lightTop(g, W, H, "rgba(255,244,220,0.3)");
}

function drawDream(g, W, H, t) {
  LEAVES.forEach((l) => {
    const y = (((t * (l.sp + 0.035) + l.ph) % 1.15) - 0.08) * H;
    const x = l.x * W + Math.sin(t * 1.1 + l.ph * 9) * 34;
    leaf(g, x, y, l.s, Math.sin(t * 1.7 + l.ph * 7) * 1.6 + t * 0.6 + l.ph * 3, l.c);
  });
}

// the still painted background is cached once; only the moving pieces are drawn each frame
const mk = (bg, fg) => (g, W, H, t, img, cache = {}) => {
  const ready = !!(img?.complete && img.naturalWidth);
  if (!cache.bg || cache.ready !== ready) {
    cache.bg = cache.bg || document.createElement("canvas");
    cache.bg.width = W;
    cache.bg.height = H;
    bg(cache.bg.getContext("2d"), W, H, img);
    cache.ready = ready;
  }
  g.drawImage(cache.bg, 0, 0);
  fg(g, W, H, t);
};
export const LOOPS = { lotus: mk(bgPond, drawPond), love: mk(bgLove, drawLove), woods: mk(bgDream, drawDream) };
